export default __webpack_public_path__ + "static/Virtual-Reality-c4412b3dcada8f9d8ef7b80d3eec157f.webp";